import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0230',
    ecrans: ['00-2'],
    params: ['?reference']
});
